import type { StaffCoordinationCustomerV2Response } from '@/types/apps/staff-coordination-customer-v2.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

type StaffCoordinationCustomerV2ListResponse = ApiResponse<
    PaginatedResult<StaffCoordinationCustomerV2Response>
>;

export class StaffCoordinationCustomerV2Service implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/v2/staff-coordination/customer',
    };

    public index(
        params?: QueryParams
    ): Promise<StaffCoordinationCustomerV2ListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }
}
